import { ISalary, ISalaryCreateDto, ISalaryPaymentDto, ISalaryUseCase } from "@lib";
import { ISalaryProcessor } from "./salary-processor";
import { ISalaryTableItem } from "../salary-table";

export class SalarySaleProcessor implements ISalaryProcessor {
    public async pay(
        companyId: string,
        accountId: string,
        item: ISalaryTableItem,
        usecase: ISalaryUseCase,
    ): Promise<ISalary> {
        const employeeId = item.meta.employee;
        const description = "Выплата за продажу";
        const subject = [
            {
                sale: {
                    amount: item.amount,
                    ref: item.meta.sale?.id as string,
                },
            },
        ];

        const salaryDto: ISalaryCreateDto = {
            account: accountId,
            amount: item.amount,
            subject: subject,
            //comment: undefined,
        };

        const paymentDto: ISalaryPaymentDto = {
            account: accountId,
            description: description,
        };

        return await usecase.create(companyId, employeeId, salaryDto, paymentDto);
    }
}
